import {ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {UserService} from '../../../../provider/user.service';
import {UserModel} from '../../../models/user.model';
import {AuthService} from '../../../../provider/auth/auth.service';
import {Subscription} from 'rxjs';
import {ProductService} from 'src/app/provider/product.service';

@Component({
  selector: 'kt-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnDestroy {
  role = 'user';
  subscriptions: Subscription[] = [];

  update = false;
  error = false;
  success = false;

  constructor(public userService: UserService,
              private authService: AuthService,
              private myService: ProductService,
              private changeDetect: ChangeDetectorRef
  ) {
    const sub = this.userService.record_change$.subscribe(
      (user: UserModel) => {
        if (user != undefined) {
          this.role = user.role;
        } else {
          this.role = authService.tokenForm.role;
        }
      }
    );
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  async updateApp() {
    this.error = false;
    this.update = true;
    const RESP = await this.myService.postPushMobileData(this.userService.record_change$.getValue().app_hotel_id);

    if (RESP) {
      this.success = true;
      this.update = false;

      setTimeout(() => {
        this.success = false;
      }, 2000);
    } else {
      this.update = false;
      this.error = true;
    }

    this.changeDetect.detectChanges();
  }
}
